<script>
import IntegrationsBase from "@/components/tools/IntegrationsBase.vue";
import Alpaclass from "@/components/tools/modals/member-area/Alpaclass.vue";
import Astron from "@/components/tools/modals/member-area/Astron.vue";
import Cademi from "@/components/tools/modals/member-area/Cademi.vue";
import Ead from "@/components/tools/modals/member-area/Ead.vue";
import Kajabi from "@/components/tools/modals/member-area/Kajabi.vue";
import Memberkit from "@/components/tools/modals/member-area/Memberkit.vue";

export default {
  extends: IntegrationsBase,
  data() {
    return {
      name: "Área de membros",
      subtitle: "Integre sua área de membros ao ZeusPay",
      newModal: true
    };
  },
  computed: {
    options() {
      return [
        {
          title: "Kajabi",
          image: require("@/assets/images/integrations/kajabi.svg"),
          description:
            "Integre sua área de membros da plataforma Kajabi ao ZeusPay",
          modal: Kajabi,
          name: "kajabi",
          link: "https://kajabi.com/"
        },
        {
          title: "Memberkit",
          image: require("@/assets/images/integrations/memberkit.svg"),
          description:
            "Integre sua área de membros da plataforma Memberkit ao ZeusPay",
          modal: Memberkit,
          name: "memberkit",
          link: "https://memberkit.com.br/"
        },
        {
          title: "Cademí",
          image: require("@/assets/images/integrations/cademi.svg"),
          description:
            "Integre sua área de membros da plataforma Cademí ao ZeusPay",
          modal: Cademi,
          name: "cademi",
          link: "https://cademi.com.br/"
        },
        {
          title: "Astron Members",
          image: require("@/assets/images/integrations/astron.svg"),
          description:
            "Integre sua área de membros da plataforma Astron Members ao ZeusPay",
          modal: Astron,
          name: "astron",
          link: "https://www.astronmembers.com.br/"
        },
        {
          title: "EAD",
          image: require("@/assets/images/integrations/ead.svg"),
          description:
            "Integre sua área de membros da EAD plataforma ao ZeusPay",
          modal: Ead,
          name: "eadplataform",
          link: "https://eadplataforma.com/"
        },
        {
          title: "Alpaclass",
          image: require("@/assets/images/integrations/alpaclass.svg"),
          description:
            "Integre sua área de membros da plataforma Alpaclass ao ZeusPay",
          modal: Alpaclass,
          name: "alpaclass",
          link: "https://www.alpaclass.com/"
        }
      ];
    }
  },
  mounted() {
    this.loading = true;
    this.$store
      .dispatch("product/get", { limit: 1000 })
      .finally(() => (this.loading = false));
  }
};
</script>
